export function DistributionWarehouseBrandImg({ img }: { img: string }) {
  return (
    <img
      src={img}
      alt=""
      style={{
        width: "20px",
        height: "20px",
        objectFit: "contain",
        flexShrink: 0,
      }}
    />
  );
}
